// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"9df03598","355":"26fcae5e","384":"40ef7c4c","511":"ee090373","905":"b5f944f5"}[chunkId] + ".chunk.js";
};